import useSession from "hooks/useSession";
import { getConfirmedTarifs } from "pages/private/ResumeRoute/ResumeRoute.util";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { confirmationCIT, confirmationPaymentCIT } from "services/api/redsys.service";
import { getPayCit, getTypeCit, setConfirmationRedsys, setConfirmedTarifsSession } from "services/user/user.session.service";
import { getItemStorage } from "services/util/sessionStorage.service";
export function ResponseCITMono() {
  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const { setConfirmedTarifs} = useSession();
  useEffect(() => {


    const status = query.get('status');
    const customers = query.get('customers');
    const orderId = query.get('orderId');
    const processId = query.get('processId');

    setConfirmationRedsys({
        processId:processId,
        orderId:orderId,
        status:status,
        customers:customers,
        typeCit:getTypeCit()
    })

    switch (getTypeCit()) {
      case 'mono':
        if(status==="ok"){
          confirmationCIT(customers,orderId,processId)
          .catch(error => {
            navigate("/confirm-planing");
          })
          
      }else{
        navigate("/resume-route");
      }
      break;

      case 'multi':
  
      if(status==="ok"){
          confirmationCIT(customers,orderId,processId)
          .catch(error => {
            confirmationPaymentCIT(
              getPayCit().tripId,
              (response: any) => {  
                const {outwardJourney,returnJourney}=getConfirmedTarifs(response.data)
                setConfirmedTarifsSession({
                  outwardJourney:outwardJourney,
                  returnJourney:returnJourney
                })
                setConfirmedTarifs({
                  outwardJourney:outwardJourney,
                  returnJourney:returnJourney
                })
                //navigate(`/resume-route`);
                navigate(`/resume-route?orderId=${orderId}`);
              },
              (err: any) => {
               navigate(`/resume-route`);


              },
              false
            );  
            navigate(`/resume-route?orderId=${orderId}`);
          })
  
        }else{
          navigate(`/resume-route?orderId=${orderId}&status=ko`);
        }
          //
        
      break;

      case 'tmb':
        if(status==="ok"){
          confirmationCIT(customers,orderId,processId)
          .catch(error => {
            navigate("/tmb-confirm-planning");
          })
    
        }else{
          navigate(`/tmb-resume-route`);
        }
     
      break;
      default:
        navigate("/confirm-planing");
        break;
    }
  });


  return (
    <>
      <div></div>
    </>
  );
}
